import { bucketsOf, type ChartSeries } from './chart-series.ts';

export const SeriesTable = ({ label, series }: { label: string; series: readonly ChartSeries[] }) => (
  <div className="visually-hidden">
    <table>
      <caption>{label}</caption>
      {series.length > 1 ? (
        <thead>
          <tr>
            <td />
            {series.map((entry) => (
              <th key={entry.key} scope="col">
                {entry.label}
              </th>
            ))}
          </tr>
        </thead>
      ) : null}
      <tbody>
        {bucketsOf(series).map((bucket, index) => (
          <tr key={bucket.key}>
            <th scope="row">{bucket.label}</th>
            {series.map((entry) => (
              <td key={entry.key}>{entry.points[index]?.display ?? ''}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
